import { listEntities } from '@neptune/shared/entity-domain';

import { knownAttributesForExperimentIdentification } from 'domain/experiment/attribute';

import { entriesToIdsAndNames } from './utils';

export async function filterArchivedEntities(
  projectIdentifier: string,
  data: {
    runIds: string[];
    experimentNames: string[];
  },
): Promise<{ runIds: string[]; experimentNames: string[] }> {
  const result = await listEntities(
    {
      projectIdentifier,
      runsIds: data.runIds,
      experimentNames: data.experimentNames,
      attributePathsFilter: knownAttributesForExperimentIdentification,
    },
    { filterArchived: true, flattenEntities: true },
  );

  const { runIds, experimentNames } = entriesToIdsAndNames(result);

  return {
    runIds: data.runIds.filter((id) => runIds.has(id)),
    experimentNames: data.experimentNames.filter((name) => experimentNames.has(name)),
  };
}
